export default __webpack_public_path__ + "static/21-cyberspace-47d9be9217a18884f7826e26a5fa097b.png";